module.exports = __webpack_public_path__ + "img/text-with-icon-hsia.8b1041c2.webp";